import React, { Component } from 'react';

class Testimonials extends Component {
  render() {
    if(!this.props.data || !this.props.data.testimonials || this.props.data.testimonials.length === 0){
      return null;
    }

    var testimonials = this.props.data.testimonials.map(function(testimonial){
      return  <article key={testimonial.user} className="recommendation-card">
          <p className="recommendation-text">{testimonial.text}</p>
          <div className="recommendation-author">
             <h3>{testimonial.user}</h3>
             <p>{testimonial.role}</p>
             <span>{testimonial.meta}</span>
          </div>
       </article>
    });

    return (
      <section id="testimonials">
      <div className="text-container">
         <div className="row">

            <div className="three columns header-col">
               <h1><span>Recommendations</span></h1>
            </div>

            <div className="nine columns recommendations-grid">
                  {testimonials}
               </div>
            </div>
         </div>
   </section>
    );
  }
}

export default Testimonials;



// WEBPACK FOOTER //
// ./src/Components/Testimonials.js